import { css } from '@emotion/css'

import { spacing } from '../../../../styles'
import { colors } from '../../../../themes'

const styles = {
  card: css({
    height: 255, // height of the card when populated, rounded from 253px
    marginBottom: spacing.medium,
  }),

  header: css({
    height: spacing.extraLarge,
    borderBottom: `1px solid ${colors.geyser}`,
    width: '100%',
  }),
}

export default styles
